// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__33sQG","error":"Textarea_error__3GsXS","readonly":"Textarea_readonly__InNG9","disabled":"Textarea_disabled__FUAN8"};